import { render, staticRenderFns } from "./estates-list-subscription.vue?vue&type=template&id=1dbbd5cc&scoped=true&"
import script from "./estates-list-subscription.vue?vue&type=script&lang=js&"
export * from "./estates-list-subscription.vue?vue&type=script&lang=js&"
import style0 from "./estates-list-subscription.vue?vue&type=style&index=0&id=1dbbd5cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbbd5cc",
  null
  
)

export default component.exports